export default "__VITE_ASSET__Dk$EffF2__"